import { createSlice } from "@reduxjs/toolkit";

const checkoutSlice = createSlice({
  name: "checkout",
  initialState: {
    checkoutItems: [],
    checkoutTotalAmount: 0,
    checkoutItemsFinalPriceWithTax: 0,
    shippingTotalAmount: 0,
  },
  reducers: {
    addCartItemsToCheckout(state, action) {
      const cartItems = action.payload;
      // replace array with a new array
      state.checkoutItems.splice(0, state.checkoutItems.length, ...cartItems);

      state.checkoutTotalAmount = state.checkoutItems.reduce(
        (curValue, nextValue) => {
          return curValue + nextValue.productPrice;
        },
        0
      );

      state.checkoutItemsFinalPriceWithTax = state.checkoutItems.reduce(
        (curValue, nextValue) => {
          return curValue + nextValue.productFinalPriceWithTax;
        },
        0
      );

      state.shippingTotalAmount = state.checkoutItems.reduce(
        (curValue, nextValue) => {
          return curValue + nextValue.shippingTtl;
        },
        0
      );
    },
    addItemToCheckout(state, action) {
      const newItem = action.payload;
      state.checkoutTotalAmount = newItem.productPrice;
      state.checkoutItemsFinalPriceWithTax = newItem.productFinalPriceWithTax;
      state.shippingTotalAmount = newItem.shippingTtl;
      state.checkoutItems.splice(0, state.checkoutItems.length, newItem);
    },
  },
});

export const checkoutAction = checkoutSlice.actions;

export default checkoutSlice;
